<template>
  <section class="chart-header-big">
    <div style="display: flex; gap: 0.5rem; flex-direction: column; min-width: 150px;">
      <div class="dates-wrapper">
        <strong>Period</strong>
        <el-select v-model="selectedOption" placeholder="Select Period">
          <el-option
            v-for="option in ranges"
            :key="option.value"
            :value="option.title"
            @click="handleClick(option)"
          >
            {{ option.title }}
          </el-option>
        </el-select>
      </div>

      <div v-if="selectedOption === 'Custom Date'">
        <div class="dates-wrapper">
          <strong>Start Date:</strong>
          <el-date-picker
            @change="handleChangeStartDate"
            v-model="startDate"
            type="date"
            placeholder="Pick a day"
            size="small"
            :disabled-date="checkDateStartDate"
          />
          <strong></strong>
        </div>
        <div class="dates-wrapper">
          <strong>End Date:</strong>
          <el-date-picker
            @change="handleChangeEndDate"
            v-model="endDate"
            type="date"
            placeholder="Pick a day"
            size="small"
            :disabled-date="checkDateEndDate"
          />
        </div>
        <strong style="justify-content: center"
          >{{ startDate ? startDate : 'No Date Selected' }} -
          {{ endDate ? endDate : 'No Date Selected' }}</strong
        >
      </div>
      <el-button type="info" @click="handleSubmit">Submit</el-button>
    </div>
    <div class="total-values-wrapper">
      <div
        v-for="total in data.filter(
          (data) => data?.value_type === 'Accumulative'
        )"
        :key="total?.name"
        class="total-value-container"
      >
        Total {{ total.label }}: <br />
        <!-- <img :src='total.img' alt='img' /> -->
        <div>{{ calcTotal(total.data, total.unit) }}</div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import configureMeasurements from 'convert-units';
import current from 'convert-units/definitions/current';
import energy from 'convert-units/definitions/energy';
import power from 'convert-units/definitions/power';
import voltage from 'convert-units/definitions/voltage';
import volume from 'convert-units/definitions/volume';

const convert = configureMeasurements({
  current,
  energy,
  power,
  voltage,
  volume
});

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      selectedOption: 'Last 30 Days',
      startDate: null,
      endDate: null,
      startDateForBE: null,
      endDateForBE: null,
      range: [moment().subtract(29, 'days'), moment()],
      ranges: [
        // {
        //   title: 'Today',
        //   value: [moment(), moment()],
        // },
        // {
        //   title: 'Yesterday',
        //   value: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        // },
        {
          title: 'Last 7 Days',
          value: [moment().subtract(6, 'days'), moment()],
        },
        {
          title: 'Last 30 Days',
          value: [moment().subtract(29, 'days'), moment()],
        },
        {
          title: 'This Month',
          value: [moment().startOf('month'), moment().endOf('month')],
        },
        {
          title: 'Last Month',
          value: [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month'),
          ],
        },
        { title: 'Custom Date', value: 'Custom Date' },
      ],
    }
  },
  methods: {
    calcTotal(data, unit) {
      let total = data.reduce((a, b) => a + b, 0)
      if (!total) return 0
      if (total > 1000000) {
        let value = convert(total).from(unit).toBest({ cutOffNumber: 1000 })
        let number = value.val.toLocaleString('en-US', {
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        })
        return `${number} [${value.unit.toUpperCase()}]`
      } else {
        let number = total.toLocaleString('en-US', {
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        })
        return `${number} [${unit.toUpperCase()}]`
      }
    },
    handleClick(range) {
      let data = JSON.parse(JSON.stringify(range))
      this.userChoice = data.title
      this.date = data.value
    },
    handleDateSelect() {
      let datesArr = []
      for (let i = 0; i < this.date.length; i++) {
        let a = moment(this.date[i])
        datesArr.push(a.format())
      }
      let strForUser = ''
      for (let i = 0; i < datesArr.length; i++) {
        let x = datesArr[i].substring(0, 10).replace(/-/g, '/')
        if (i === 0) {
          strForUser += x + ' - '
        } else {
          strForUser += x
        }
      }
      this.userChoice = strForUser
    },
    handleSubmit() {
      let dateFrom, dateTo
      if (this.selectedOption === 'Custom Date') {
        if (!this.startDateForBE || !this.endDateForBE) {
          console.log(this.startDateForBE)
          console.log(this.endDateForBE)
          return
        }
        dateFrom = this.startDateForBE
        dateTo = this.endDateForBE
      } else {
        let datesArr = []
        for (let i = 0; i < this.date.length; i++) {
          let currDate = JSON.parse(JSON.stringify(this.date[i]))
          if (currDate.length === 10) {
            datesArr.push(currDate)
          } else {
            let a = moment(currDate)
            if (i === 1) {
              a = a.add(1, 'days')
            }
            datesArr.push(a.format('YYYY-MM-DD'))
          }
        }
        dateFrom = datesArr[0]
        dateTo = datesArr[1]
      }
      let params = {
        ts_from: dateFrom,
        ts_to: dateTo,
        aggregation: 'Daily',
      }
      console.log(params)
      this.$emit('filterChanged', params)
    },
    checkDateEndDate(e) {
      const receivedDate = new Date(this.startDate)
      const today = new Date()
      if (e > today || e < receivedDate) {
        return true
      } else {
        return false
      }
    },
    checkDateStartDate(e) {
      let receivedDate = null
      if (this.endDate) {
        receivedDate = new Date(this.endDate)
      }
      const today = new Date()
      if (e > today || (receivedDate && e > receivedDate)) {
        return true
      } else {
        return false
      }
    },
    handleChangeStartDate(e) {
      if (!e) {
        this.startDate = null
        this.startDateForBE = null
        return
      }
      let a = moment(e)
      let dateForUser = a.format('YYYY-MM-DD')
      this.startDate = formatDate(dateForUser)
      this.startDateForBE = dateForUser
    },
    handleChangeEndDate(e) {
      if (!e) {
        this.endDate = null
        this.endDateForBE = null
        return
      }
      let a = moment(e)
      let dateForUser = a.format('YYYY-MM-DD')
      this.endDate = formatDate(dateForUser)
      a = a.add(1, 'days')
      this.endDateForBE = a.format('YYYY-MM-DD')
    },
  },
  components: {
    Datepicker,
  },
}
</script>

<style>
strong {
  font-size: 11px;
  font-weight: bold;
  color: #404040;
  align-self: flex-start;
  display: flex;
  padding-left: 2px;
}
</style>
